import React from "react";
import { Sparkles } from "lucide-react";

const CircularLoader = ({
  size = "md",
  variant = "primary",
  showText = true,
  text = "Loading...",
  className = "",
}) => {
  const sizeClasses = {
    sm: "w-12 h-12",
    md: "w-16 h-16",
    lg: "w-20 h-20",
    xl: "w-24 h-24",
  };

  const variantClasses = {
    primary: {
      outer: "border-primary-100",
      middle: "border-primary-300",
      inner: "border-primary-500",
      center: "text-primary-500",
    },
    accent: {
      outer: "border-accent-100",
      middle: "border-accent-300",
      inner: "border-accent-500",
      center: "text-accent-500",
    },
    secondary: {
      outer: "border-secondary-100",
      middle: "border-secondary-300",
      inner: "border-secondary-500",
      center: "text-secondary-500",
    },
  };

  const currentVariant = variantClasses[variant];
  const currentSize = sizeClasses[size];

  return (
    <div className={`text-center ${className}`}>
      <div className={`relative ${currentSize} mx-auto mb-4`}>
        {/* Multiple rotating rings for beautiful effect */}
        <div
          className={`absolute inset-0 border-4 ${currentVariant.outer} rounded-full animate-pulse`}
        ></div>

        {/* Outer spinning ring */}
        <div
          className={`absolute inset-0 border-4 border-transparent border-t-4 ${currentVariant.middle} rounded-full search-loading-primary`}
        ></div>

        {/* Middle spinning ring */}
        <div
          className={`absolute inset-0 border-4 border-transparent border-t-4 ${currentVariant.inner} rounded-full search-loading-secondary`}
          style={{ animationDelay: "0.2s" }}
        ></div>

        {/* Inner spinning ring */}
        <div
          className={`absolute inset-0 border-4 border-transparent border-t-4 ${currentVariant.inner} rounded-full search-loading-accent`}
          style={{ animationDelay: "0.4s" }}
        ></div>

        {/* Center sparkle icon */}
        <div
          className={`absolute inset-0 flex items-center justify-center ${currentVariant.center}`}
        >
          <div className="mobile-loading-center">
            <Sparkles
              className={`${
                size === "sm"
                  ? "w-4 h-4"
                  : size === "md"
                  ? "w-6 h-6"
                  : size === "lg"
                  ? "w-8 h-8"
                  : "w-10 h-10"
              }`}
            />
          </div>
        </div>
      </div>

      {showText && (
        <div className="space-y-1">
          <p
            className={`font-semibold text-gray-700 font-jakarta loading-text-primary ${
              size === "sm"
                ? "text-sm"
                : size === "md"
                ? "text-base"
                : size === "lg"
                ? "text-lg"
                : "text-xl"
            }`}
          >
            {text}
          </p>
          <p
            className={`text-gray-500 font-jakarta loading-text-secondary ${
              size === "sm"
                ? "text-xs"
                : size === "md"
                ? "text-sm"
                : size === "lg"
                ? "text-base"
                : "text-lg"
            }`}
          >
            Please wait...
          </p>
        </div>
      )}
    </div>
  );
};

export default CircularLoader;
